import React, {useMemo} from 'react'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext.tsx'
import {StatsTable} from '../../StatsTable/index.ts'
import {RESOURCE_ACTIVITY_IMAGE_PATH, RESOURCE_ACTIVITY_TRANSLATION} from '../../../constants.ts'

export const ResourceStats = () => {
    const {gameEndData, playersByRank} = useUIGameEndContext()
    const players = useMemo(() => playersByRank.flatMap((player) => player.color), [playersByRank])

    const headers = useMemo(() => Object.keys(RESOURCE_ACTIVITY_IMAGE_PATH).map((key) => ({
        imagePath: RESOURCE_ACTIVITY_IMAGE_PATH[key],
        tooltip: RESOURCE_ACTIVITY_TRANSLATION[key].title,
    })), [])

    const rows = useMemo(() => players.map((player) => {
        const row: number[] = []
        const data = gameEndData.endGameState.resourceStats[player]
        if(data === undefined) return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        row.push(data.totalResourceIncome)
        row.push(data.totalResourceLoss)
        row.push(data.totalResourceScore)
        row.push(data.rollingIncome)
        row.push(data.robbingIncome)
        row.push(data.devCardIncome)
        row.push(data.tradeIncome)
        row.push(data.rollingLoss)
        row.push(data.robbingLoss)
        row.push(data.devCardLoss)
        row.push(data.tradeLoss)
        row.push(data.goldIncome)
        return row
    }), [players])

    return <>
        <StatsTable headers={headers} rows={rows}/>
    </>
}
